"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const react_modal_1 = __importDefault(require("react-modal"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
exports.default = (0, styled_1.default)(react_modal_1.default) `
	// Mobile styles
	.travelnest-modal .button span + span {
		margin-left: 5px;
	}

	.travelnest-modal {
		max-height: 75vh;
	}

	.travelnest-modal__hero {
		width: 100%;
	}

	.travelnest-modal__button-close {
		width: 40px;
		display: flex;
		justify-content: center;
	}

	.travelnest-modal__button-close-content {
		display: flex;
		flex-flow: column;
		align-items: center;
		padding-top: 3px;

		// this is getting added to the Icon component otherwise it doesnt render
		div:first-of-type {
			width: 20px;
			height: 20px;
		}
	}

	.travelnest-modal__button-close-text {
		display: none;
	}

	.travelnest-modal__button-close span {
		padding-top: 3px;
		font-family: ${merlin_theme_1.default.typography.fonts.base};
	}

	.travelnest-modal__header {
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid ${merlin_theme_1.default.colours.delimiter.default};
		padding: ${merlin_theme_1.default.layout.spacing.standard};
	}

	.travelnest-modal__title {
		padding-top: 5px;
		margin: 0;
		font-size: ${merlin_theme_1.default.typography.b1.fontSize};
		line-height: ${merlin_theme_1.default.typography.b1.lineHeight};
		font-weight: bolder;
		color: ${merlin_theme_1.default.colours.neutral.darkest};
		font-family: ${merlin_theme_1.default.typography.fonts.base};
	}

	.travelnest-modal__contain {
		overflow-x: hidden;
		overflow-y: auto;
		height: calc(100% - 150px);
	}

	.travelnest-modal__content {
		padding: ${merlin_theme_1.default.layout.spacing.standard};
	}

	.travelnest-modal__action-row {
		background: ${merlin_theme_1.default.colours.background.lighter};
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 15px ${merlin_theme_1.default.layout.spacing.standard};
		border-top: 1px solid ${merlin_theme_1.default.colours.delimiter.default};
		box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
		height: 70px;
	}

	.travelnest-modal__action-row > * {
		font-family: ${merlin_theme_1.default.typography.fonts.base};
	}

	/* tablet and up */

	@media only screen and (min-width: 760px) {
		.travelnest-overlay {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.travelnest-modal {
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
			max-width: 600px;
		}

		.travelnest-modal__button-close {
			width: auto;
			display: flex;
			justify-content: center;
		}

		.travelnest-modal__button-close-content {
			flex-flow: nowrap;
		}

		.travelnest-modal__button-close-text {
			display: inline;
			padding-left: 3px;
		}

		.travelnest-modal__button-close span {
			padding-top: 0;
		}

		.travelnest-modal__button-close span + span {
			margin-left: 10px;
		}

		.travelnest-modal__contain {
			display: flex;
			flex-direction: column;
		}

	}

`;
//# sourceMappingURL=modal.styled.js.map